// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"961fbacf959e3ada","6831":"29ab7b503c79da8a","8503":"74defdc3a265d479","9683":"940d1bbe73ab5bd8"}[chunkId] + ".js";
};